import data from "../../../../../packages/react/src/SelectPanel/SelectPanel.docs.json";
import DeprecationBanner from "../../../../components/DeprecationBanner";
import * as React from 'react';
export default {
  data,
  DeprecationBanner,
  React
};